const Container = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="relative h-screen w-full overflow-hidden bg-ro-map font-int text-ro-black">
      {children}
    </div>
  );
};

export default Container;
